export enum IconColor {
  BLACK = "black",
  WHITE = "white",
  COLOR = "color",
}

export default IconColor;
